import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import { getFeaturesAtPoint } from "fond/draw/modes/planner/dropAssignments/helper";

interface DrawCustomModeState {
  popupOpen: boolean;
}

/**
 * Allow the user to select a cable/assignment to reassign by clicking on it.
 */
const selectDrop: DrawCustomMode<DrawCustomModeState> = {
  onSetup: function () {
    return {
      popupOpen: false,
    };
  },

  toDisplayFeatures: function (_, geojson, display) {
    if (geojson.type === "Feature" && geojson.properties) {
      geojson.properties.draw_mode = "selectDrop";
      geojson.properties.hidden = false;
    }
    display(geojson);
  },

  onClick: function (state, event) {
    // The user clicked on the map while the popup was open; we assume that
    // means the user is trying to close the popup.
    this.map.fire("drop_assignments.hide_cable_selection");

    const cables = getFeaturesAtPoint(this, event.point, 7, ["assignmentCable", "cable"]);
    if (cables.length === 0) {
      return;
    }

    if (cables.length === 1) {
      this.changeMode("draw_assignment", { selectedCable: cables[0] });
      return;
    }

    // There are multiple cables near the click - fire an event to show a selection popup.
    state.popupOpen = true;
    this.map.fire("drop_assignments.show_cable_selection", { cables, lngLat: this.map.unproject(event.point) });
  },
};

export default selectDrop;
